/* StatusFlowComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./StatusFlowRenderer");

class StatusFlowComponent extends EventEmitter {
    constructor(config) {
        super();
        const defaultConfig = {
            flowPoints: ["Draft", "Validate", "Bundle", "Upgrade"],
            draft: {
                default: {
                    label: "Draft",
                    class: "",
                },
                saved: {
                    label: "Draft",
                    class: "success",
                },
            },
            validate: {
                default: {
                    label: "Validate",
                    class: "",
                },
                validated: {
                    label: "Validate",
                    class: "success",
                },
                error: {
                    label: "Validate",
                    class: "error",
                },
                canceled: {
                    label: "Validate",
                    class: "default",
                },
                validating: {
                    label: "Validate",
                    class: "running",
                },
            },
            bundle: {
                default: {
                    label: "Bundle",
                    class: "",
                },
                bundling: {
                    label: "Bundle",
                    class: "running",
                },
                bundled: {
                    label: "Bundle",
                    class: "success",
                },
                bundle_error: {
                    label: "Bundle",
                    class: "error",
                },
            },
            upgrade: {
                default: {
                    label: "Upgrade",
                    class: "",
                },
                update_complete: {
                    label: "Upgrade",
                    class: "success",
                },
                update_error: {
                    label: "Upgrade",
                    class: "error",
                },
                update_incomplete: {
                    label: "Upgrade",
                    class: "incomplete",
                },
                update_error: {
                    label: "Upgrade",
                    class: "error",
                },
                uploading_results: {
                    label: "Upgrade",
                    class: "running",
                },
            },
        };
        this._config = _.extend({}, defaultConfig, config);

        this._flowPoints = this._config.flowPoints;
        this._registerListeners();
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this._config = undefined;
            this._flowPoints = undefined;
        });
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    setState(flowPoint, state) {
        this.emit("setState", {flowPoint, state});
    }

    resetAll() {
        this.emit("resetAllStates");
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = StatusFlowComponent;
